import React from "react";
import { AddStationsOrPodcastsLoaderTemplate } from "themes/common/components";

function AddStationsOrPodcastsLoader(props) {
    return <AddStationsOrPodcastsLoaderTemplate {...props} />;
}

export default AddStationsOrPodcastsLoader;
